import { render, staticRenderFns } from "./layananPendidikan.vue?vue&type=template&id=4034aa27&"
import script from "./layananPendidikan.vue?vue&type=script&lang=js&"
export * from "./layananPendidikan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QBtnGroup,QBtn,QMarkupTable,QPagination,QDialog,QCard,QCardSection,QImg,QCardActions} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBtnGroup,QBtn,QMarkupTable,QPagination,QDialog,QCard,QCardSection,QImg,QCardActions})
